/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface GlobalPlannerRequestActionArgs {
  /**
   * Deprecate and replace with global_planner.GlobalPlannerRequest when the message definition is
   * stable
   */
  encodedRequest: Uint8Array;
}

export interface GlobalPlannerRequestActionResultData {
}

export interface GlobalPlannerRequestActionStateData {
}

function createBaseGlobalPlannerRequestActionArgs(): GlobalPlannerRequestActionArgs {
  return { encodedRequest: new Uint8Array(0) };
}

export const GlobalPlannerRequestActionArgs = {
  encode(message: GlobalPlannerRequestActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.encodedRequest.length !== 0) {
      writer.uint32(18).bytes(message.encodedRequest);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalPlannerRequestActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalPlannerRequestActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.encodedRequest = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalPlannerRequestActionArgs {
    return {
      encodedRequest: isSet(object.encodedRequest) ? bytesFromBase64(object.encodedRequest) : new Uint8Array(0),
    };
  },

  toJSON(message: GlobalPlannerRequestActionArgs): unknown {
    const obj: any = {};
    if (message.encodedRequest.length !== 0) {
      obj.encodedRequest = base64FromBytes(message.encodedRequest);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalPlannerRequestActionArgs>, I>>(base?: I): GlobalPlannerRequestActionArgs {
    return GlobalPlannerRequestActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalPlannerRequestActionArgs>, I>>(
    object: I,
  ): GlobalPlannerRequestActionArgs {
    const message = createBaseGlobalPlannerRequestActionArgs();
    message.encodedRequest = object.encodedRequest ?? new Uint8Array(0);
    return message;
  },
};

function createBaseGlobalPlannerRequestActionResultData(): GlobalPlannerRequestActionResultData {
  return {};
}

export const GlobalPlannerRequestActionResultData = {
  encode(_: GlobalPlannerRequestActionResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalPlannerRequestActionResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalPlannerRequestActionResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GlobalPlannerRequestActionResultData {
    return {};
  },

  toJSON(_: GlobalPlannerRequestActionResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalPlannerRequestActionResultData>, I>>(
    base?: I,
  ): GlobalPlannerRequestActionResultData {
    return GlobalPlannerRequestActionResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalPlannerRequestActionResultData>, I>>(
    _: I,
  ): GlobalPlannerRequestActionResultData {
    const message = createBaseGlobalPlannerRequestActionResultData();
    return message;
  },
};

function createBaseGlobalPlannerRequestActionStateData(): GlobalPlannerRequestActionStateData {
  return {};
}

export const GlobalPlannerRequestActionStateData = {
  encode(_: GlobalPlannerRequestActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalPlannerRequestActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalPlannerRequestActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GlobalPlannerRequestActionStateData {
    return {};
  },

  toJSON(_: GlobalPlannerRequestActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalPlannerRequestActionStateData>, I>>(
    base?: I,
  ): GlobalPlannerRequestActionStateData {
    return GlobalPlannerRequestActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalPlannerRequestActionStateData>, I>>(
    _: I,
  ): GlobalPlannerRequestActionStateData {
    const message = createBaseGlobalPlannerRequestActionStateData();
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
